import i18n from '@/lang/i18n'

export default function() {
    return [
        { type: 'customCheckbox' },
        {
            type: 'readIndicator',
            headerName: i18n.t('notifications.status'),
            colId: 'read',
            field: 'read',
            minWidth: 100,
            flex: 1
        },
        {
            type: 'dateTime',
            headerName: i18n.t('notifications.dateTime'),
            colId: 'timestamp',
            field: 'timestamp',
            minWidth: 140,
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('notifications.entityId'),
            colId: 'label',
            field: 'label',
            minWidth: 160,
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('notifications.title'),
            colId: 'subject',
            field: 'subject',
            minWidth: 180,
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('notifications.message'),
            colId: 'body',
            field: 'body',
            minWidth: 440,
            flex: 1,
            sortable: false
        },
        {
            type: 'notificationEntityType',
            headerName: i18n.t('notifications.entity'),
            colId: 'entityType',
            field: 'entityType',
            minWidth: 120,
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.tc('global.laboratory', 1),
            colId: 'laboratory.labName',
            field: 'laboratory',
            minWidth: 140,
            flex: 1
        }
    ]
}
